module.exports = __webpack_public_path__ + "static/why-smart-people-make-big-money-mistakesand-how-to-correct-them-318b281f21c57216703970badf1db9d2.jpg";